import './style.css';
import { LuClipboardCheck, LuCloudUpload, LuFilePenLine } from 'react-icons/lu';

const stepIcons = {
  '01': LuCloudUpload,
  '02': LuFilePenLine,
  '03': LuClipboardCheck,
};

const ProcessArrow = () => (
  <svg className="project-process__arrow" viewBox="0 0 120 16" fill="none" aria-hidden="true">
    <path d="M1 8H112" stroke="currentColor" strokeWidth="2" strokeDasharray="5 5" strokeLinecap="round" />
    <path d="M102 -2L120 8L102 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ProjectProcess = ({ data }) => {
  if (!data?.items?.length) return null;
  return (
    <section className="project-process">
      <h2 className="project-process__title">{data.title}</h2>

      <ol className="project-process__list">
        {data.items.map(({ id, title, text }, index) => {
          const Icon = stepIcons[id];
          return (
          <li key={id} className="project-process__step">
            <div className="project-process__head">
              <span className="project-process__number">{id}</span>
              <span className="project-process__icon">
                {Icon ? <Icon /> : null}
              </span>
            </div>

            <div className="project-process__copy">
              <h3>{title}</h3>
              <p>{text}</p>
            </div>

            {index < data.items.length - 1 ? (
              <span className="project-process__arrow-wrap">
                <ProcessArrow />
              </span>
            ) : null}
          </li>
          );
        })}
      </ol>
    </section>
  );
};

export default ProjectProcess;
